import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "group relative flex h-full flex-col overflow-hidden rounded-2xl border border-sand-200 bg-white shadow-warm-sm transition-all duration-300 focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-offset-2 hover:-translate-y-1 hover:border-sand-300 hover:shadow-warm-lg" }
const _hoisted_2 = { class: "relative aspect-[4/3] overflow-hidden bg-sand-100" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "flex h-full w-full items-center justify-center bg-linear-to-br from-sand-100 to-sand-200 text-ink-300"
}
const _hoisted_5 = { class: "absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-white/95 px-3 py-1 text-xs font-semibold text-ink-800 shadow-warm-sm backdrop-blur" }
const _hoisted_6 = ["aria-label", "aria-pressed", "disabled"]
const _hoisted_7 = {
  key: 0,
  class: "spinner spinner-sm",
  role: "status",
  "aria-label": "Loading"
}
const _hoisted_8 = {
  key: 2,
  class: "absolute bottom-3 left-3 inline-flex items-center gap-1 rounded-full bg-ink-900/60 px-2.5 py-1 text-xs font-medium text-white backdrop-blur"
}
const _hoisted_9 = {
  key: 3,
  class: "absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-ink-900/60 px-2.5 py-1 text-xs font-medium text-white backdrop-blur"
}
const _hoisted_10 = { class: "flex flex-1 flex-col p-5" }
const _hoisted_11 = { class: "flex items-start justify-between gap-3" }
const _hoisted_12 = { class: "line-clamp-1 font-display text-lg font-semibold leading-snug text-ink-900" }
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = {
  key: 0,
  class: "mt-1 line-clamp-1 flex items-center gap-1.5 text-sm text-ink-500"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-3 line-clamp-2 text-sm leading-relaxed text-ink-600"
}

import { computed, ref, watch } from "vue";
import type { HotelDisplay } from "@/stores/hotel.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'PropertyCard',
  props: {
    hotel: {},
    isFavourite: { type: Boolean },
    favouritePending: { type: Boolean }
  },
  emits: ["toggle-favourite"],
  setup(__props: any) {

const props = __props;



const imageFailed = ref(false);
watch(
  () => props.hotel.image,
  () => (imageFailed.value = false)
);

const typeIcon = computed(() =>
  /apartment|short/i.test(props.hotel.type || "")
    ? "bi-house-door"
    : "bi-building"
);

const photoCount = computed(() => props.hotel.imageUrls?.length || 0);

const formattedRating = computed(() => props.hotel.rating.toFixed(1));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.hotel.image && !imageFailed.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.hotel.image,
            alt: `${__props.hotel.name}${__props.hotel.location ? `, ${__props.hotel.location}` : ''}`,
            loading: "lazy",
            decoding: "async",
            class: "h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105",
            onError: _cache[0] || (_cache[0] = ($event: any) => (imageFailed.value = true))
          }, null, 40, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "bi bi-building text-5xl" }, null, -1)
          ]))])),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "pointer-events-none absolute inset-0 bg-linear-to-t from-ink-900/45 via-transparent to-ink-900/15" }, null, -1)),
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("i", {
          class: _normalizeClass(['bi', typeIcon.value, 'text-primary-600'])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(__props.hotel.type || "Hotel"), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white/95 shadow-warm-sm backdrop-blur transition-transform duration-200 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 disabled:cursor-not-allowed disabled:opacity-60",
        "aria-label": 
          __props.isFavourite ? 'Remove from favourites' : 'Add to favourites'
        ,
        "aria-pressed": __props.isFavourite,
        disabled: __props.favouritePending,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-favourite', __props.hotel.id)))
      }, [
        (__props.favouritePending)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7))
          : (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: _normalizeClass([
            'bi text-base',
            __props.isFavourite
              ? 'bi-heart-fill text-red-500'
              : 'bi-heart text-ink-700',
          ])
            }, null, 2))
      ], 8, _hoisted_6),
      (__props.hotel.distance)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-geo-alt-fill" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(__props.hotel.distance), 1)
          ]))
        : _createCommentVNode("", true),
      (photoCount.value > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-images" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(photoCount.value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h3", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: { name: 'hotel-details', params: { id: __props.hotel.id } },
            class: "after:absolute after:inset-0 after:content-[''] focus:outline-none"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.hotel.name), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        (__props.hotel.rating > 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "inline-flex shrink-0 items-center gap-1 rounded-md bg-gold-50 px-2 py-0.5 text-sm font-semibold text-ink-800",
              "aria-label": `Rated ${__props.hotel.rating} out of 5`
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-star-fill text-xs text-gold-500" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(formattedRating.value), 1)
            ], 8, _hoisted_13))
          : _createCommentVNode("", true)
      ]),
      (__props.hotel.location)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-geo-alt text-primary-500" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(__props.hotel.location), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.hotel.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(__props.hotel.description), 1))
        : _createCommentVNode("", true),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "min-h-4 flex-1" }, null, -1)),
      _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "flex items-center justify-between border-t border-sand-200 pt-4 text-sm font-semibold text-primary-600",
        "aria-hidden": "true"
      }, [
        _createTextVNode(" View details "),
        _createElementVNode("span", { class: "flex h-8 w-8 items-center justify-center rounded-full bg-primary-50 transition-all duration-300 group-hover:translate-x-1 group-hover:bg-primary-500 group-hover:text-white" }, [
          _createElementVNode("i", { class: "bi bi-arrow-right" })
        ])
      ], -1))
    ])
  ]))
}
}

})